import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserEntity, UserService } from '@thg-procure-team/procure-common-ui/business/user';
import { AutoUnsubscribable } from '@thg-procure-team/procure-common-ui/platform/domain';
import { ThgcMaintenanceService } from '@thg-procure-team/procure-common-ui/platform/maintenance';
import { ThgcTableStateService } from '@thg-procure-team/procure-common-ui/platform/table';
import dayjs from 'dayjs';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Component({
  selector: 'thg-root',
  template: `
    <thgc-maintenance *ngIf="isMaintenance$ | async; else app"></thgc-maintenance>

    <ng-template #app>
      <thgc-toast></thgc-toast>
      <thgc-router-resolve-progressbar></thgc-router-resolve-progressbar>
      <thg-layout-home *ngIf="canDisplay$ | async"></thg-layout-home>
    </ng-template>
  `,
  standalone: false,
})
export class AppComponent extends AutoUnsubscribable implements OnInit {
  public canDisplay$: Observable<boolean>;
  public isMaintenance$: Observable<boolean>;

  constructor(
    private readonly thgcMaintenanceService: ThgcMaintenanceService,
    private readonly thgcTableStateService: ThgcTableStateService,
    private readonly userService: UserService,
    private readonly router: Router,
  ) {
    super();
  }

  public ngOnInit(): void {
    this.thgcTableStateService.setState('shared', {
      requisitions: {
        dateFrom: dayjs().subtract(3, 'month').toDate(),
        dateTo: new Date(),
      },
      purchaseOrders: {
        dateFrom: dayjs().subtract(3, 'month').toDate(),
        dateTo: new Date(),
      },
      deliveries: {
        dateFrom: dayjs().subtract(2, 'month').toDate(),
        dateTo: dayjs().add(1, 'month').toDate(),
      },
      invoices: {
        dateFrom: dayjs().subtract(3, 'month').toDate(),
        dateTo: new Date(),
      },
      fundingRequests: {
        dateFrom: dayjs().subtract(3, 'month').toDate(),
        dateTo: new Date(),
      },
    });
    this.isMaintenance$ = this.thgcMaintenanceService.isMaintenance$;
    this.canDisplay$ = this.userService.user$.pipe(
      tap((user) => this.checkPreviousRouterState(user)),
      map((user) => !!user),
    );
  }

  private checkPreviousRouterState(user: UserEntity): void {
    if (user?.delegationTo) {
      this.router.navigate(['/delegations']);
    }
  }
}
